import { render, staticRenderFns } from "./order-setting-sub-module.vue?vue&type=template&id=58cde306&scoped=true&"
import script from "./order-setting-sub-module.vue?vue&type=script&lang=js&"
export * from "./order-setting-sub-module.vue?vue&type=script&lang=js&"
import style0 from "./order-setting-sub-module.vue?vue&type=style&index=0&id=58cde306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cde306",
  null
  
)

export default component.exports